import { useEffect, useState } from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { useCoachStore } from '@/stores/coachStore'
import { ProgramListView } from '@/components/programs/ProgramListView'
import { ProgramCreateView } from '@/components/programs/ProgramCreateView'
import { ProgramDetailView } from '@/components/programs/ProgramDetailView'
import { ProgramEditView } from '@/components/programs/ProgramEditView'
import { ProgramDayAssignmentView } from '@/components/programs/ProgramDayAssignmentView'

export function ProgramsPage() {
  const { setCurrentPage } = useCoachStore()
  const { programId } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  
  const [currentView, setCurrentView] = useState<'list' | 'create' | 'detail' | 'edit' | 'assign-days'>('list')

  useEffect(() => {
    setCurrentPage('programs')
  }, [setCurrentPage])

  useEffect(() => {
    // Determine the current view based on the route
    if (location.pathname === '/programs/create') {
      setCurrentView('create')
    } else if (location.pathname === '/programs/assign-days') {
      setCurrentView('assign-days')
    } else if (programId && location.pathname.includes('/edit')) {
      setCurrentView('edit')
    } else if (programId) {
      setCurrentView('detail')
    } else {
      setCurrentView('list')
    }
  }, [location.pathname, programId])

  const handleCreateProgram = () => {
    navigate('/programs/create')
  }

  const handleBackToList = () => {
    navigate('/programs')
  }

  const handleViewProgram = (id: string) => {
    navigate(`/programs/${id}`)
  }

  const handleEditProgram = (id: string) => {
    navigate(`/programs/${id}/edit`)
  }

  const handleAssignmentComplete = () => {
    navigate('/programs')
  }

  const handleSkipAssignment = () => {
    navigate('/programs')
  }

  return (
    <div className="space-y-6">
      {currentView === 'list' && (
        <ProgramListView onCreateProgram={handleCreateProgram} />
      )}
      
      {currentView === 'create' && (
        <ProgramCreateView onBack={handleBackToList} />
      )}
      
      {currentView === 'detail' && programId && (
        <ProgramDetailView 
          programId={programId}
          onBack={handleBackToList}
          onEdit={() => handleEditProgram(programId)}
        />
      )}
      
      {currentView === 'edit' && programId && (
        <ProgramEditView 
          programId={programId}
          onBack={() => handleViewProgram(programId)}
          onSave={handleBackToList}
        />
      )}
      
      {currentView === 'assign-days' && (
        <ProgramDayAssignmentView 
          onComplete={handleAssignmentComplete}
          onSkip={handleSkipAssignment}
        />
      )}
    </div>
  )
}